import { downgradeInjectable } from '@angular/upgrade/static';
import { NetworkService } from '@fry-it/risr-core';

(function() {
  'use strict';

  angular.module('blocks.network')
    .service('NetworkService', downgradeInjectable(NetworkService));
})();
